import React, {Component, Fragment} from 'react';
import {_get, _put, _post} from "../Api";
import FormUploadFiles from "../Components/FormUploadFiles";
import {Button, FormGroup, Label} from "reactstrap";
import Select from "react-select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloudUploadAlt, faWindowClose, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import md5 from 'md5'

import XLSX from 'xlsx'
import Loader from "../Components/Loader";

class Import extends Component {

    constructor(props) {
        super(props);
        this.state = {
            api: false,
            fieldsSet: [],
            selectFields: [],
            map_id: 0,
            loading: false
        };

        this.handleUploadImages = this.handleUploadImages.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectGroup = this.handleSelectGroup.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    async queryAPI() {
        await _get(this.props.db + "/fields", this.state.args).then(res => {
            this.setState({api: res.data}, () => {
                this.setTableFields()
            })
        })
    }

    handleSuccess() {
        this.props.notificationComponent({type: "success", message: ["Import done"]})
        this.props.hideComponent({component: 'refreshList'})
    }

    queryPostAPI() {
        (this.state.selectedFiles) && this.state.selectedFiles.map((file) => {
            let formData = new FormData();
            formData.append('files', file)
            _post(this.props.db + "/import/" + this.state.map_id, formData).then(res => {
                (res.result === 'success')
                ? this.handleSuccess()
                : this.props.notificationComponent({type: "error", message: res.data.messages})
            })
        })
    }

    setTableFields() {
        let newObject = []
        let templateObject = []
        Object.values(this.state.api.fields).map((field, i) => {
            if (field.primary_key !== 1 &&
                field.name !== 'created_at' &&
                field.name !== 'updated_at' &&
                field.name !== 'deleted_at') {
                newObject[field.name] = false
                templateObject.push(field.name)
            }
        })

        this.setState({fieldsSet: newObject})
        this.setState({templateObj: templateObject})
    }

    handleUploadImages(files) {

        this.setState({selectedFiles: files})
    }

    async handleChange(e) {
        this.setState({loading: true})
        this.queryAPI()

        const extensionXlsList = ['csv', 'xls', 'xlt', 'xla', 'xlsx', 'xltx', 'xlsm', 'xltm', 'xlam', 'xlsb'];
        const extension = e[0].name.split('.').pop().toLowerCase();
        const isXlsFile = !!extension && extensionXlsList.includes(extension);

        if (isXlsFile) {
            const XLS = e[0];
            const data = await XLS.arrayBuffer();
            const workbook = XLSX.read(data, {
                sheetRows: 1,
                bookSheets: 0
            });

            let result = [];
            Object.values(workbook.Sheets).map(sheet => {
                Object.keys(sheet).map(key => {
                    if (!key.includes("!")) {
                        result.push(sheet[key].v)
                    }
                })
            })

            this.setFileFields(result)

            const json = md5(JSON.stringify([this.state.templateObj, this.state.objHeaders]))
            this.setState({map_id: 0});
            const params = {search: {json: json}}
            _get("import_map", params).then(res => {
                if (res.result === 'success' && res.data.pager.total > 0) {
                    const response = res.data.list[0];
                    this.setState({map_id: response.id});

                    const data = JSON.parse(response.data);
                    let newArray = this.state.fieldsSet;
                    Object.keys(data).map(key => {
                        if (data[key].value) {
                            let i = data[key].index
                            let v = data[key].value
                            newArray[i] = v
                        }
                    })
                    this.setState({fieldsSet: newArray}, () => {
                        this.fileFields()
                    })
                }

                this.setState({loading: false})
            })


        }
    }

    setFileFields(fields) {

        let fileData = [];
        Object.values(fields).map((field, i) => {
            const data = {
                label: field,
                value: field
            }
            fileData.push(data)
        })
        this.setState({objHeaders: fileData}, () => {
            this.fileFields();
        })
    }

    fileFields() {
        const tableFields = this.state.fieldsSet

        let unselected = {label: "Unselected", options: []}
        let selected = {label: "Selected", options: []}
        Object.values(this.state.objHeaders).map((field, i) => {
            (this.containsObject(field, tableFields)) ? selected.options.push(field) : unselected.options.push(field)
        })

        this.setState({selectFields: [{label: 'Empty', value: null}, unselected, selected]})
    }

    handleSelectGroup(e, i) {
        if (i.action === 'select-option') {
            let newData = this.state.fieldsSet;
            newData[i.name] = (e.value !== null) ? e : false
            this.setState({fieldsSet: newData}, () => {
                this.fileFields()
            })
        }
    }

    containsObject(obj, list) {
        let result = false
        Object.values(list).map(field => {
            if (field === obj) {
                result = true
            }
        })

        return result
    }

    handleFormSubmit(e) {
        e.preventDefault();
        const data = []
        Object.keys(this.state.fieldsSet).map(key => {
            data.push({index: key, value: this.state.fieldsSet[key]})
        })

        const json = [this.state.templateObj, this.state.objHeaders]

        const submitData = {
            json: md5(JSON.stringify(json)),
            data: JSON.stringify(data)
        }

        if (this.state.map_id === 0) {
            _put("import_map", submitData).then(res => {
                (res.result === 'success')
                    ? this.setState({map_id: res.data.inserted_id}, () => {
                        this.queryPostAPI()
                    })
                    : this.props.notificationComponent({type: "error", message: ["Error on saving error map"]})

            })
        } else {
            this.queryPostAPI()
        }


    }

    render() {
        return (
            <Fragment>
                {(this.props.returnurl !== false) &&
                <Button onClick={() => this.props.hideComponent({component: 'showList'})}
                        outline
                        color={"secondary"}
                        className="mb-3">
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                </Button>
                }

                <form onSubmit={this.handleFormSubmit}>
                    <FormUploadFiles upload={this.handleUploadImages} onChange={this.handleChange}/>
                    {!this.state.loading ?
                        <Fragment>
                            {(this.state.templateObj && this.state.templateObj.length > 0) &&
                            <FormGroup>
                                {this.state.fieldsSet && Object.keys(this.state.fieldsSet).map((field, i) => {
                                    const fieldDefaultValue = (this.state.fieldsSet[field].length === 0) ? null : this.state.fieldsSet[field]
                                    return (
                                        <div className="row mb-3" key={i}>
                                            <Label for={field}
                                                   className="col-sm-2 col-4 col-form-label">{field}</Label>
                                            <div className="col-sm-10 col-8">
                                                <Select name={field}
                                                        value={fieldDefaultValue}
                                                        options={this.state.selectFields}
                                                        classNamePrefix="select2-selection"
                                                        onChange={this.handleSelectGroup}/>
                                            </div>
                                        </div>
                                    )
                                })}
                                <div className="row mb-3">
                                    <div className="col-2"/>
                                    <div className="col-10">
                                        <Button outline
                                                color="primary"
                                                className="me-2">
                                            <FontAwesomeIcon icon={faCloudUploadAlt}/> Submit
                                        </Button>
                                        <Button onClick={() => this.props.hideComponent({component: 'showList'})}
                                                outline
                                                color={"secondary"}>
                                            <FontAwesomeIcon icon={faWindowClose}/> Cancel
                                        </Button>
                                    </div>
                                </div>
                            </FormGroup>
                            }
                        </Fragment>
                        :
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <Loader isLoading={true}/>
                                </div>
                            </div>
                        </div>
                    }
                </form>
            </Fragment>
        );
    }
}

export default Import